import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { loadableReady } from '@loadable/component';
import { RouterProvider } from 'react-router-dom';

import '@lib/sentry/client';

// eslint-disable-next-line import-x/order
import './reset.scss';

import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';

import '@gravity-ui/uikit/styles/fonts.css';
import '@gravity-ui/uikit/styles/styles.css';

import { initApp } from '@components/App/App.utils/initApp';
import { ClientContextProvider } from '@client/lib/ClientContext';

import { router } from './router';

// Переопределения для gravity-ui (чтобы фон не был белым от темы)
import './index.scss';

polyfillCountryFlagEmojis();

function hideSplashScreen() {
    const splashScreen = document.querySelector<HTMLElement>('.SplashScreen');

    if (!splashScreen) return;

    splashScreen.classList.add('SplashScreen_hide');

    setTimeout(() => {
        splashScreen.remove();
    }, 250);
}

initApp().then(() => {
    const rootNode = document.getElementById('root');

    if (rootNode === null) {
        return;
    }

    loadableReady(() => {
        hydrateRoot(rootNode, (
            <ClientContextProvider>
                <RouterProvider router={router} />
            </ClientContextProvider>
        ));

        hideSplashScreen();
    });
});
